import { render, staticRenderFns } from "./TifTurnoPozosSatelites.vue?vue&type=template&id=3409a37a"
import script from "./TifTurnoPozosSatelites.vue?vue&type=script&lang=js"
export * from "./TifTurnoPozosSatelites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports